import {Button, CTABanner} from '@primer/react-brand'

import type {PrimerComponentCtaBanner} from '../../../lib/types/contentful'
import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {BLOCKS} from '@contentful/rich-text-types'

export type ContentfulCtaBannerProps = {
  component: PrimerComponentCtaBanner
}

export function ContentfulCtaBanner({component}: ContentfulCtaBannerProps) {
  return (
    <CTABanner
      align={component.fields.align}
      hasBorder={component.fields.hasBorder}
      hasShadow={component.fields.hasShadow}
      hasBackground={component.fields.hasBackground}
    >
      <CTABanner.Heading>{component.fields.heading}</CTABanner.Heading>

      <CTABanner.Description>
        {documentToReactComponents(component.fields.description, {
          renderNode: {
            [BLOCKS.PARAGRAPH]: (_, children) => children,
          },
        })}
      </CTABanner.Description>
      <CTABanner.ButtonGroup>
        <Button as="a" href={component.fields.callToActionPrimary.fields.href}>
          {component.fields.callToActionPrimary.fields.text}
        </Button>
        <Button as="a" href={component.fields.callToActionSecondary.fields.href}>
          {component.fields.callToActionSecondary.fields.text}
        </Button>
      </CTABanner.ButtonGroup>
    </CTABanner>
  )
}

try{ ContentfulCtaBanner.displayName ||= 'ContentfulCtaBanner' } catch {}